import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["as", "src", "background", "altText", "gatsbyImageProps", "children", "className"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable react/forbid-prop-types */


import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import { ChildrenPropType } from '../../../services/proptypes';
import { getOldImage } from '../../../utils/gatsby';
var defaultProps = {
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null,
  className: ''
};

var ImageOld = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ImageOld, _React$PureComponent);

  var _super = _createSuper(ImageOld);

  function ImageOld() {
    _classCallCheck(this, ImageOld);

    return _super.apply(this, arguments);
  }

  _createClass(ImageOld, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as,
          src = _this$props.src,
          background = _this$props.background,
          altText = _this$props.altText,
          gatsbyImageProps = _this$props.gatsbyImageProps,
          children = _this$props.children,
          className = _this$props.className,
          extraProps = _objectWithoutProperties(_this$props, _excluded);

      var imageData = getOldImage(src);

      var allGatsbyImageProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, extraProps), gatsbyImageProps), imageData), {}, {
        alt: altText,
        className: "legacy-gatsby-image ".concat(className)
      });

      if (background) {
        return /*#__PURE__*/React.createElement(BackgroundImage, _extends({
          Tag: as
        }, allGatsbyImageProps), children);
      }

      return /*#__PURE__*/React.createElement(Img, allGatsbyImageProps);
    }
  }]);

  return ImageOld;
}(React.PureComponent);

ImageOld.defaultProps = defaultProps;
export default ImageOld;